import React, { FunctionComponent } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Paper, Typography } from '@mui/material';

export const ErrorPage: FunctionComponent = () => {
    const location: any = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const message = queryParams.get('message');

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                backgroundColor: '#f5f5f5',
                padding: 3
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    padding: 6,
                    maxWidth: 500,
                    width: '100%',
                    textAlign: 'center',
                    borderRadius: 2
                }}
            >
                <Typography
                    variant="h4"
                    component="h1"
                    gutterBottom
                    sx={{
                        fontWeight: 600,
                        color: 'text.primary',
                        mb: 2,
                        fontSize: '1.8rem'
                    }}
                >
                    Oh No! Something went wrong
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        color: 'text.secondary',
                        mb: 4,
                        lineHeight: 1.6
                    }}
                >
                    {message}
                </Typography>
            </Paper>
        </Box>
    );
};